import { render } from "./CompanyUserSelect.vue?vue&type=template&id=3ae93c8a"
import script from "./CompanyUserSelect.vue?vue&type=script&lang=js"
export * from "./CompanyUserSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__